import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=4d2a2f49&"
import script from "./RoleModal.vue?vue&type=script&lang=js&"
export * from "./RoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2a2f49')) {
      api.createRecord('4d2a2f49', component.options)
    } else {
      api.reload('4d2a2f49', component.options)
    }
    module.hot.accept("./RoleModal.vue?vue&type=template&id=4d2a2f49&", function () {
      api.rerender('4d2a2f49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/RoleModal.vue"
export default component.exports